import { inject, injectable } from 'tsyringe';
import { type IAgentUserTokenRepository } from 'application/repositorySchemas/IAgentUserTokenRepository';
import { type IAgentChatRepository } from 'application/repositorySchemas/IAgentChatRepository';
import { type IAgentSendChatClient } from 'interfaceAdapter/gatewaySchemas/IAgentSendChatClient';
import { type IAgentSetMeetingDateClient } from 'interfaceAdapter/gatewaySchemas/IAgentSetMeetingDateClient';
import { type IAgentDeclineMeetingDateClient } from 'interfaceAdapter/gatewaySchemas/IAgentDeclineMeetingDateClient';
import { type IAgentConfirmMeetingDateClient } from 'interfaceAdapter/gatewaySchemas/IAgentConfirmMeetingDateClient';

@injectable()
export class AgentChatRepository implements IAgentChatRepository {
    constructor(
        @inject('IAgentUserTokenRepository')
        public readonly agentUserToken: IAgentUserTokenRepository,
        @inject('IAgentSendChatClient')
        public readonly sendChatClient: IAgentSendChatClient,
        @inject('IAgentSetMeetingDateClient')
        public readonly setMeetingDateClient: IAgentSetMeetingDateClient,
        @inject('IAgentDeclineMeetingDateClient')
        public readonly declineMeetingDateClient: IAgentDeclineMeetingDateClient,
        @inject('IAgentConfirmMeetingDateClient')
        public readonly confirmMeetingDateClient: IAgentConfirmMeetingDateClient,
    ) {}

    public async send(chat_room_id: number, message: string) {
        const { data, message: resMessage } = await this.sendChatClient.post({
            token: this.agentUserToken.get() || '',
            chat_room_id,
            message,
        });

        if (resMessage) {
            throw new Error(resMessage);
        }

        return data;
    }

    public async setMeetingDate(match_id: number, meeting_date: string) {
        const { data, message } = await this.setMeetingDateClient.post({
            token: this.agentUserToken.get() || '',
            match_id,
            meeting_date,
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }

    public async declineMeetingDate(match_id: number) {
        const { data, message } = await this.declineMeetingDateClient.post({
            token: this.agentUserToken.get() || '',
            match_id,
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }

    public async confirmMeetingDate(match_id: number) {
        const { data, message } = await this.confirmMeetingDateClient.post({
            token: this.agentUserToken.get() || '',
            match_id,
        });

        if (message) {
            throw new Error(message);
        }

        return data;
    }
}
